import Subheader from 'src/components/util/Subheader';

/**
 * Notice required by the Utah Government Data Privacy Act whenever a form collects personal data.
 * The wording is prescribed, so keep it verbatim and reuse this component rather than restating it.
 *
 * @returns {JSX.Element} - The DataPrivacyNotice component.
 */
export default function DataPrivacyNotice() {
  return (
    <>
      <Subheader>Utah Government Data Privacy Act Notice</Subheader>
      <p className="text-sm">
        When a government agency requests an individual to provide personal data, the Utah
        Government Data Privacy Act requires a government agency to provide notice to the individual
        as to the reason for requesting the personal data, how the personal data will be used and
        the consequences for not providing the personal data. This form requests personal data to
        identify the business, business owner(s), and verify or update account data. The information
        provided will be used in determining your business personal property tax liability. If the
        requested information is not provided, we may be unable to update your business personal
        property account information, and your account may be subject to an estimated assessment.
        Personal data may be disclosed as necessary to verify leased equipment or shared with
        authorized Utah County departments and state agencies in connection with appeals and audits.
        This data is collected and maintained in accordance with the applicable record series and as
        required in Utah Code 63G-2-307.
      </p>
    </>
  );
}
